/**
 * The locale namespace for the studio core.
 *
 * @internal
 * @hidden
 */
export const studioLocaleNamespace = 'studio' as const

/**
 * The namespace for validation messages.
 *
 * @internal
 * @hidden
 */
export const validationLocaleNamespace = 'validation' as const

/**
 * The namespace for copy/paste messages.
 *
 * @internal
 * @hidden
 */
export const copyPasteLocalNamespace = 'copy-paste' as const
